import React, { useContext, useEffect, useState } from 'react';
import styles from '../../styles/dashboard.module.css';
import Header from '../../components/header/header';
import PageTitle from '../../components/page_title/page_title';
import axiosInstance from '../../AxiosInstance';
import MyContext from '../../Context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWrench, faClock, faClipboardList, faBoxOpen, faSearch } from '@fortawesome/free-solid-svg-icons';
import MaintenanceHoursTab from './maintenance_hours';
import MaintenancePlansTab from './maintenance_plans';
import MaintenanceRecordsTab from './maintenance_records';
import MaintenancePartsTab from './maintenance_parts';
import {useTranslation} from 'react-i18next';

const TABS_CONFIG = [
    { id: 'hours',   labelKey: 'maintenance.tabHours',   icon: faClock },
    { id: 'plans',   labelKey: 'maintenance.tabPlans',   icon: faWrench },
    { id: 'records', labelKey: 'maintenance.tabRecords', icon: faClipboardList },
    { id: 'parts',   labelKey: 'maintenance.tabParts',   icon: faBoxOpen },
];

export default function MaintenanceDashboard() {
    const {t} = useTranslation();
    const project_id = parseInt(localStorage.getItem('project_id'));
    const [machines, setMachines] = useState([]);
    const [selectedMachine, setSelectedMachine] = useState(null);
    const [activeTab, setActiveTab] = useState('hours');
    const [search, setSearch] = useState('');
    const { setCompanyChange } = useContext(MyContext);

    const filteredMachines = machines.filter(m =>
        m.name.toLowerCase().includes(search.toLowerCase())
    );

    useEffect(() => {
        setCompanyChange(prev => prev + 1);
        if (!project_id) return;
        axiosInstance.get('machine/?project_id=' + project_id).then(res => {
            const list = res.data.filter(m => !m.deleted_at);
            setMachines(list);
            if (list.length > 0) setSelectedMachine(list[0]);
        });
    }, [project_id]);

    return (
        <div className={styles.dashboard_container}>
            <Header sidebarIndex={-1} />
            <div className={styles.dashboardInnerContainer}>
                <PageTitle title={t('maintenance.title')} />

                {/* Machine search + selector */}
                <div className="mt-3" style={{ position: 'relative', maxWidth: '280px', marginBottom: '10px' }}>
                    <FontAwesomeIcon
                        icon={faSearch}
                        style={{ position: 'absolute', left: '10px', top: '50%', transform: 'translateY(-50%)', color: '#94A3B8', fontSize: '13px', pointerEvents: 'none' }}
                    />
                    <input
                        type="text"
                        placeholder={t('maintenance.searchMachines')}
                        value={search}
                        onChange={e => setSearch(e.target.value)}
                        style={{
                            width: '100%',
                            padding: '7px 10px 7px 30px',
                            borderRadius: '8px',
                            border: '1px solid #E2E8F0',
                            fontSize: '14px',
                            color: '#334155',
                            outline: 'none',
                        }}
                    />
                </div>
                <div className="d-flex gap-2 flex-wrap">
                    {filteredMachines.map(m => (
                        <div
                            key={m.id}
                            role="button"
                            onClick={() => {
                                setSelectedMachine(m);
                                setActiveTab('hours');
                            }}
                            style={{
                                padding: '8px 16px',
                                borderRadius: '8px',
                                background: selectedMachine?.id === m.id ? '#4F46E5' : '#F1F5F9',
                                color: selectedMachine?.id === m.id ? '#FFF' : '#334155',
                                cursor: 'pointer',
                                fontWeight: 500,
                                fontSize: '14px',
                                border: '1px solid',
                                borderColor: selectedMachine?.id === m.id ? '#4F46E5' : '#E2E8F0',
                                transition: 'all 0.15s',
                            }}
                        >
                            {m.name}
                        </div>
                    ))}
                    {machines.length === 0 && (
                        <p style={{ color: '#94A3B8', fontSize: '14px', margin: 0 }}>
                            {t('maintenance.noMachines')}
                        </p>
                    )}
                    {machines.length > 0 && filteredMachines.length === 0 && (
                        <p style={{ color: '#94A3B8', fontSize: '14px', margin: 0 }}>
                            No machines match "{search}".
                        </p>
                    )}
                </div>

                {selectedMachine && (
                    <>
                        {/* Tab bar */}
                        <div className="d-flex gap-2 mt-4 mb-3 flex-wrap">
                            {TABS_CONFIG.map(tab => (
                                <div
                                    key={tab.id}
                                    role="button"
                                    onClick={() => setActiveTab(tab.id)}
                                    style={{
                                        padding: '8px 18px',
                                        borderRadius: '6px',
                                        cursor: 'pointer',
                                        background: activeTab === tab.id ? '#4F46E5' : '#F8FAFC',
                                        color: activeTab === tab.id ? '#FFF' : '#64748B',
                                        border: '1px solid',
                                        borderColor: activeTab === tab.id ? '#4F46E5' : '#E2E8F0',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '8px',
                                        fontWeight: 500,
                                        fontSize: '14px',
                                        transition: 'all 0.15s',
                                    }}
                                >
                                    <FontAwesomeIcon icon={tab.icon} />
                                    {t(tab.labelKey)}
                                </div>
                            ))}
                        </div>

                        {/* Tab content */}
                        {activeTab === 'hours'   && <MaintenanceHoursTab machine={selectedMachine} />}
                        {activeTab === 'plans'   && <MaintenancePlansTab machine={selectedMachine} />}
                        {activeTab === 'records' && <MaintenanceRecordsTab machine={selectedMachine} />}
                        {activeTab === 'parts'   && <MaintenancePartsTab machine={selectedMachine} />}
                    </>
                )}
            </div>
        </div>
    );
}
